export default __webpack_public_path__ + "static/media/Toilet-pictogram.36d57f2a.svg";